export const LIST_CREDIT_LOGS = 'LIST_CREDIT_LOGS'; 
export const CHANGE_CREDIT = 'CHANGE_CREDIT';
export const CREATE_PARTNER = 'CREATE_PARTNER';
export const EXPORT_CREDIT_LOG = 'EXPORT_CREDIT_LOG';
export const REPORT_CREDIT_LOGS = 'REPORT_CREDIT_LOGS';